var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1605",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 13,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.00024H15.02V20.5021H3V5.00024Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1605)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.208 6.50613C11.34 6.50613 10.23 7.38713 9.30598 8.12113C8.41698 8.82613 7.71498 9.38413 7.01498 9.43613C6.70498 9.45813 6.43898 9.46813 6.20498 9.47613C5.45798 9.50113 5.26898 9.51813 4.93198 9.79613C4.48998 10.1591 4.49698 11.6421 4.50098 12.5271L4.50198 12.7481V12.7521L4.50098 12.9731C4.49698 13.8591 4.48998 15.3421 4.93198 15.7051C5.26798 15.9831 5.45698 15.9991 6.20198 16.0261C6.43698 16.0331 6.70398 16.0431 7.01498 16.0661C7.71498 16.1171 8.41698 16.6751 9.30598 17.3801C10.409 18.2551 11.776 19.3401 12.681 18.8891C13.439 18.2321 13.52 16.4901 13.52 12.7501C13.52 9.01013 13.439 7.26913 12.681 6.61113C12.534 6.53813 12.375 6.50613 12.208 6.50613ZM12.218 20.5021C10.827 20.5021 9.44798 19.4071 8.37398 18.5551C7.88898 18.1701 7.15598 17.5881 6.90298 17.5621C6.61598 17.5401 6.36798 17.5311 6.14898 17.5251C5.35098 17.4961 4.71998 17.4751 3.97798 16.8631C2.98598 16.0461 2.99498 14.3381 3.00098 12.9661L3.00198 12.7501L3.00098 12.5341C2.99498 11.1621 2.98598 9.45513 3.97798 8.63813C4.72098 8.02613 5.35298 8.00413 6.15298 7.97713C6.37098 7.96913 6.61798 7.96113 6.90498 7.94013C7.15598 7.91313 7.88898 7.33113 8.37398 6.94613C9.77198 5.83513 11.689 4.31813 13.474 5.33513C13.505 5.35413 13.536 5.37413 13.564 5.39713C14.958 6.49213 15.02 8.55713 15.02 12.7501C15.02 16.9441 14.958 19.0091 13.564 20.1051C13.536 20.1271 13.505 20.1481 13.473 20.1661C13.059 20.4021 12.638 20.5021 12.218 20.5021Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3306 17.1869C18.2036 17.1869 18.0756 17.1549 17.9576 17.0869C17.5986 16.8809 17.4746 16.4219 17.6806 16.0639C18.8516 14.0229 18.8516 11.4849 17.6806 9.43793C17.4746 9.07793 17.5996 8.61993 17.9586 8.41393C18.3186 8.21193 18.7756 8.33293 18.9816 8.69193C20.4166 11.1999 20.4166 14.3099 18.9816 16.8099C18.8426 17.0519 18.5906 17.1869 18.3306 17.1869Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeDown);
export default __webpack_public_path__ + "static/media/VolumeDown.56df0528ef008118262af22908c7ccfb.svg";
export { ForwardRef as ReactComponent };